module.exports = __webpack_public_path__ + "img/5fb5813.png";